'use strict';

window.$ = window.jQuery = require('jquery');

const MorphBy = require('./morphBy');
const DialogPlugin = require('./dialog');

const jquerySetup = {
    init() {
        console.log('jQuery plugins initialized');
        this.initCustomPlugins();
    },

    initCustomPlugins() {
        $.extend($.fn, {
            morphBy: MorphBy,
            dialog: DialogPlugin,
        });
    }
};

module.exports = jquerySetup;
